import { PlayerState } from '@sky-uk-ott/client-lib-js-player-addons-common-player';

export function playerStateToString(state: PlayerState): string {
    const stateName = PlayerState[state];
    return stateName;
}
